module.exports = __webpack_public_path__ + "img/360-note.6c1e74ee.svg";